import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import {Router} from '@angular/router';
import { CONSENT_CATEGORIES, ConsentCategoryKey, CookieConsentService } from '../services/cookie-consent.service';
import { ANALYTICS_EVENTS, AnalyticsService} from '../services/analytics.service';

@Component({
  selector: 'app-cookie-consent',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './cookie-consent.component.html',
  styleUrl: './cookie-consent.component.css',
})
export class CookieConsentComponent {
  protected readonly consentService = inject(CookieConsentService);
  protected readonly categoryKeys = Object.keys( CONSENT_CATEGORIES ) as ConsentCategoryKey[];
  protected readonly categories = CONSENT_CATEGORIES;

    private router = inject(Router);
    private analyticsService = inject( AnalyticsService );


    // Local draft state for the modal toggles, seeded from current consent.
  protected draft: Record<ConsentCategoryKey, boolean> = this.buildDraft();

  protected openSettings(): void {
    this.draft = this.buildDraft();
    this.consentService.openSettings();
  }

  protected toggle(key: ConsentCategoryKey): void {
    if (this.categories[key].required) return;
    this.draft = { ...this.draft, [key]: !this.draft[key] };
  }

  protected savePreferences(): void {
    this.consentService.savePreferences(this.draft);
  }

  private buildDraft(): Record<ConsentCategoryKey, boolean> {
    const current = this.consentService.consent();
    const draft = {} as Record<ConsentCategoryKey, boolean>;
    this.categoryKeys.forEach((key) => {
      draft[key] = this.categories[key].required
        ? true
        : !!current?.categories[key];
    });
    return draft;
  }

    protected readonly alert = alert;
    protected readonly CONSENT_CATEGORIES = CONSENT_CATEGORIES;

    protected navigateTo(url: string) {
        switch( url ) {
            case "/cookie-policy":
                this.analyticsService.track( ANALYTICS_EVENTS[ 'COOKIEPOLICY' ] , "" );
                break;
            case "/privacy-policy":
                this.analyticsService.track( ANALYTICS_EVENTS[ 'PRIVACYPOLICY' ] , "" );
                break;
            default:
                ;
        }
        this.router.navigate( [ url ] );
    }
}
